// extracted by mini-css-extract-plugin
module.exports = {"sizesSheetButton":"SizesSheet_sizesSheetButton__A4crh","sizesSheetHeader":"SizesSheet_sizesSheetHeader__re1h7","selectable":"SizesSheet_selectable__GWomx"};